import { WSTableCell, WSTableColumn } from "@wingspanhq/fe-component-library";
import { PayerRow, PayerStatus } from "@wingspanhq/wingspan-api-sdk";
import { selectorSearchRowName } from "../../../../shared/selectors/selectorSearchRowName";

/**
 * Columns for the v3 `searchPayerRows`-backed clients table, rendered off the
 * denormalized `PayerRow`. Keeps the v1 clients columns (Name / Contact) and adds
 * the Engagements the row now carries — v1 had that column built but commented
 * out ("temporarily hide") because the v1 row didn't carry engagement names.
 *
 * On XS, v1 showed Name + Contact; Status is the column dropped there, since the
 * active list is filtered to Activated and reads the same on every row.
 * See V3_MIGRATION_TRACKER.md (payer-rows §).
 */

export const getColumns = (): WSTableColumn<PayerRow>[] => [
  {
    config: {
      gridTemplateSizeMin: "0",
      gridTemplateSizeMax: "1.5fr",
      header: { text: "Name" }
    },
    renderFunction: rowItem => {
      const name = selectorSearchRowName(rowItem.data) || "--";
      return <WSTableCell avatar={{ type: "text", text: name }} text={name} />;
    }
  },
  {
    config: {
      gridTemplateSizeMin: "0",
      gridTemplateSizeMax: "1fr",
      header: { text: "Contact" }
    },
    renderFunction: rowItem => <WSTableCell text={rowItem.data.email || "--"} />
  },
  {
    config: {
      gridTemplateSizeMin: "0",
      gridTemplateSizeMax: "1fr",
      header: { text: "Engagements" },
      hideOnScreens: ["XS"]
    },
    renderFunction: rowItem => {
      const names = (rowItem.data.engagements ?? [])
        .map(e => e.name)
        .filter(Boolean);
      return (
        <WSTableCell
          text={names[0] ?? "--"}
          secondaryText={
            names.length > 1 ? `+${names.length - 1} more` : undefined
          }
        />
      );
    }
  },
  {
    config: {
      gridTemplateSizeMin: "0",
      gridTemplateSizeMax: "0.6fr",
      header: { text: "Status" },
      hideOnScreens: ["XS"]
    },
    renderFunction: rowItem => {
      const isActive = rowItem.data.status === PayerStatus.ACTIVATED;
      return (
        <WSTableCell
          pill={{
            icon: true,
            theme: isActive ? "success" : "neutral",
            text: isActive ? "Active" : "Inactive"
          }}
        />
      );
    }
  }
];
